import { lazy } from 'react';

const Merchants = lazy(() => import('../../admin/merchants/AdminMerchantsPage'));

const ManagerMerchantsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'manager/merchants',
      element: <Merchants />,
    },
  ],
};

export default ManagerMerchantsConfig;
